import React, { FunctionComponent, useEffect, useState } from 'react';
import Container from '@material-ui/core/Container';
import styles from "./Common.module.scss";
import { data } from './local';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { getToken, getReportURL, getNominatorMail, getUserGraphId} from './common';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  DataGrid, GridColDef, GridToolbarExport, GridToolbarFilterButton
} from '@mui/x-data-grid';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography'
import { GridToolbarContainer, GridToolbar, gridClasses } from '@mui/x-data-grid';
import { GridFilterModel } from '@mui/x-data-grid';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { alignProperty } from '@mui/material/styles/cssUtils';
import { Break } from 'devextreme-react/chart';
import { appInsights } from '../AppInsights';
import { getAwardeeList} from './services';


const ViewNominations: FunctionComponent<any> = () => {
  let reportUrl:any = getReportURL();

  const getcorrelationId = () => {
    return sessionStorage.getItem("correlationId");
  }

  useEffect(()=>{
      {appInsights.trackPageView({name:"ViewNominationsPageLoaded",properties:{CorrelationId:getcorrelationId(),AccountIdentifier: getUserGraphId()}})}
  },[])
  let history: any = useHistory()
  const [token, setToken] = useState<any>(null);
  useEffect(() => {
    getToken().then((token: any) => {
      setToken(token);
    });
  }, [])

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

 
 
  const iframe = reportUrl;

  function Iframe(props:any) {
    return (<div dangerouslySetInnerHTML={ {__html:  props.iframe?props.iframe:""}} />);
  }
  
  
  return (
    <React.Fragment>
      <Container maxWidth={"xl"}>
        <div className={styles.adminPage}>
          {reportUrl != null? <Iframe iframe={iframe}/>:<></>}
        </div>
        <div>

        </div>
      </Container>
    </React.Fragment>
  );
}


const useStyles1 = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      //  margin: theme.spacing(1),
      minWidth: 120,
      float: 'right',
      marginTop: theme.spacing(-15),
    },
    selectEmpty: {
      marginTop: theme.spacing(100),
      position: 'relative'
    },
  }),
);
const DateSelect = ({ showStyleDark, handleYearChange, year }: any) => {
  const classes = useStyles1();
  const languageSelected: any = useSelector((state: any) => state.lang);
  const languageData: any = data;
  const { nominationSection } = languageData[languageSelected];

  const years: any = [];
  for (let i = 0; i < 5; i++) {
    years.push(new Date().getFullYear() - 4 + i)
  }

  return (
    <FormControl className={classes.formControl}>
      <InputLabel className={showStyleDark ? styles.nominationYearSelectorDark : styles.nominationYearSelectorLite} shrink id="demo-simple-select-placeholder-label-label">
        {"Year"}
      </InputLabel>
      <Select
        labelId="demo-simple-select-placeholder-label-label"
        id="demo-simple-select-placeholder-label"
        value={year}
        onChange={handleYearChange}
        displayEmpty
        className={showStyleDark ? styles.nominationYearSelectorDark : styles.nominationYearSelectorLite}
      >
        {
          years.map((year: any, key: number) => {
            return <MenuItem key={key} value={year}>{year}</MenuItem>
          })
        }

      </Select>
    </FormControl>

  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: 0,
      fontFamily: 'Barlow !important',

      '& .MuiDataGrid-cell:hover': {
        color: '#00338e',
      },
      '& .MuiDataGrid-columnHeader': {
        color: '#FFFFFF',
        backgroundColor: '#00338e',
        fontSize: 'calc(2px + 2vmin)',
        '& .MuiCheckbox-root svg path': {
          color: 'white',
        }
      },
      '& .MuiDataGrid-columnHeadersInner': {
        backgroundColor: '#00338e'
      },
      '& .MuiDataGrid-cell': {
        fontSize: 'calc(7px + 1vmin)'
      },
      '& .MuiCheckbox-root svg path': {
        color: '#00338e',
      }
    },
    dropdownStyle:
    {
      color: "#00338e",
      backgroundColor: '#fffff',
    }
  }),
);

export default ViewNominations;